import { Link } from 'react-router-dom'
import Logo from '../components/Logo'

export default function DeleteData() {
  return (
    <div className="min-h-[100dvh] px-6 py-12" style={{ background: 'var(--fp-bg)', color: 'var(--fp-text)' }}>
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <Logo size="md" />
        </div>

        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'var(--fp-font-heading)' }}>Delete Your Data</h1>
        <p className="text-sm mb-8" style={{ color: 'var(--fp-text-muted)' }}>How to request deletion of your FlickPick account and data</p>

        <div className="space-y-6 text-sm leading-relaxed" style={{ color: 'var(--fp-text-muted)' }}>
          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>What data do we store?</h2>
            <p>
              When you log in to FlickPick with Facebook, we store your name, email address,
              and profile picture. We also store your movie watchlists, ratings, picks, and
              group memberships within the app.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>How to request deletion</h2>
            <p className="mb-3">
              To delete your FlickPick account and all associated data, please email us at:
            </p>
            <a
              href="mailto:hello@findability.com.au?subject=FlickPick%20Data%20Deletion%20Request"
              className="inline-block px-6 py-3 rounded-xl font-semibold text-base no-underline transition-all hover:brightness-110"
              style={{ background: 'var(--fp-red)', color: '#fff' }}
            >
              hello@findability.com.au
            </a>
            <p className="mt-4">
              Please include the email address associated with your FlickPick account in your
              request. We will delete your account and all personal data within 30 days of
              receiving your request.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>What gets deleted</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Your user profile (name, email, profile picture)</li>
              <li>Your movie ratings and watchlist entries</li>
              <li>Your group memberships</li>
              <li>Your movie pick history</li>
            </ul>
            <p className="mt-3">
              Note: Shared group data (such as movies added to a group watchlist) may be retained
              in anonymised form so the group's history remains intact for other members.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--fp-text)' }}>Revoking Facebook permissions</h2>
            <p>
              You can also revoke FlickPick's access to your Facebook account at any time by
              visiting your{' '}
              <a
                href="https://www.facebook.com/settings?tab=applications"
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
                style={{ color: 'var(--fp-red)' }}
              >
                Facebook App Settings
              </a>{' '}
              and removing FlickPick from your connected apps.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link to="/login" className="text-sm underline" style={{ color: 'var(--fp-text-muted)' }}>
            &larr; Back to FlickPick
          </Link>
        </div>
      </div>
    </div>
  )
}
